import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import vendingMachineSlice from "../features/vendingMachine/vendingMachineSlice";

export const store = configureStore({
  reducer: {
    vendingMachine: vendingMachineSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
